module.exports = "pegasus_template/assets/themecapture1/design/100.png";